import React from "react";
import Header from "../../elements/Header";
import Footer from "../../elements/Footer";
import FAQ from "../../elements/FAQ";
import ShopButton from "../../elements/ShopButton";
import { useNavigate } from "react-router-dom";
import useWallet from "../../hooks/useWallet";

const Wallet = () => {
  const navigate = useNavigate();

  const { balance: walletAmount } = useWallet();

  return (
    <>
      <Header search={false} />
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div
          style={{
            padding: "15px",
            display: "flex",
            flexDirection: "column",
            flex: 1,
            borderTop: "1px solid black",
            marginTop: 35,
          }}
        >
          <div css={{ maxWidth: "1140px", margin: "0 auto", width: "100%" }}>
            <div style={{ ...styles.title }}>Wallet</div>
            <p
              style={{
                fontSize: "1rem",
                fontWeight: "600",
                padding: "0px 0 10px 5px",
              }}
            >
              Fullproof balance
            </p>
            <div
              style={{
                ...styles.wallet.container,
                // bacground image
                backgroundImage: "url('/images/wallet-card.jpg')",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                maxHeight: 300,
                maxWidth: "100%",
              }}
            >
              <div style={{ ...styles.wallet.content }}>
                <img
                  src="/images/fullproof_logo_white.svg"
                  alt="Fullproof"
                  style={{ marginTop: 10, height: 45 }}
                />
              </div>
              <div
                style={{ ...styles.wallet.amount, marginTop: 20 }}
              >{`$${walletAmount?.toFixed(0) || 0}`}</div>
            </div>
            <p
              style={{
                padding: "20px 0 0 0",
                fontWeight: "500",
                fontSize: ".8rem",
              }}
            >
              Use this balance just like cash. Your balance will automatically
              apply to your next order.
            </p>
            <p
              style={{
                fontSize: "1.1rem",
                fontWeight: "600",
                padding: "20px 0 10px 0",
              }}
            >
              Earn Rewards
            </p>
            <p
              style={{ padding: "0px 0", fontWeight: "500", fontSize: ".8rem" }}
            >
              Earn rewards you can use on your next order! Simply click below to
              learn more.
            </p>
            <div style={{ marginTop: 20 }}>
              <ShopButton
                text="Learn More"
                theme="dark"
                onClick={() => navigate("/rewards")}
              />
            </div>
            <div style={{ height: 100 }} />
            <FAQ />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

const styles = {
  title: {
    fontSize: "1.5rem",
    fontWeight: "600",
    marginBottom: 20,
  },
  wallet: {
    container: {
      display: "flex",
      justifyContent: "center",
      borderRadius: 8,
      overflow: "hidden",
      position: "relative",
      aspectRatio: "16/9",
      // shadow
      boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.5)",
    },
    amount: {
      fontFamily: "Inter",
      fontSize: "3.5rem",
      fontWeight: "900",
      padding: "0px 0 10px 0",
      zIndex: 100,
      position: "absolute",
      width: "100%",
      height: "100%",
      justifyContent: "center",
      alignItems: "center",
      display: "flex",
      color: "white",
    },
    content: {
      zIndex: 100,
      color: "white",
    },
    image: {
      width: "100%",
      height: "auto",
    },
  },
};

export default Wallet;
